export class AddLetterModel {
  firmTemplateId: number;
  templateName: string = '';
  engagementId: number;
  jsonFilePath: string;
  subModuleId: number;
  masterTemplateId: number = 0;
  engagementTemplateId: number = 0;
  clientFirmId: number = 0;
  isManagementLetter: boolean = false;
}

export interface SignatureLetterModel {
  id?: number;
  signedDate?: string;
  signType?: string;
  signText?: string;
  filePath?: string;
  fileUrl?: string;
  signedBy?: number;
  signedByName?: string;
}

export interface LetterSectionModel {
  engagementTemplateId?: number;
  templateName?: string;
  jsonFilePath?: string;
  sectionName?: string;
  firmSignatureId?: number;
  jsonFileName?: string;
  clientSignoffDate?: string;
  firmTemplateId?: number;
  masterTemplateId?: number;
  clientFirmId?: number;
  subModuleId?: number;
  subModuleUUID?: string;
  userName?: string;
  manualAcceptedDate: string;
  isDefaultLetter?: boolean;
  firmSignoffDate?: string;
  isManagementLetter: boolean;
  signOffDate?: string;

  // Firm Signature
  firmSign?: SignatureLetterModel;

  // Sent Info
  isSent?: boolean;
  sentByUser?: number;
  sentByUserName?: string;
  sentDate?: string; // Use `Date` if you're transforming in interceptors or services

  // Resent Info
  isResent?: boolean;
  resentByUser?: number;
  reSentByUserName?: string;
  resentDate?: string;

  // Client Signature
  isClientAccepted?: boolean;
  clientSign?: SignatureLetterModel;
  approvedByUser: number;
  approvedByUserName: string;
}

export class ElementsResponseModel {
  addressBoardOfDirectors: string = 'To Board of Directors';
  addressManagement: string = 'To management';
  addressShareholders: string = 'To shareholders';
  balanceSheet: string = 'Balance Sheet';
  city: string;
  cityAndProvince: string;
  cityAndState: string | null;
  clientCity: string;
  clientfirmid: number;
  completeAddress: string;
  contactPerson: string | null;
  country: string;
  entityName: string;
  financialYearEnddate: string;
  firmAddress: string;
  firstName: string;
  lastName: string;
  noteX: string = 'Add a note';
  partnerName: string;
  postCode: string;
  previousYearEndDate: string;
  state: string;
  statementOfCashflow: string | null;
  statementOfIncomeAndRetainedEarnings: string = 'statement of income and retained earnings';
  streetAddress: string;
}

export class ShareStatusModel {
  hasSign: boolean = false;
  hasPortal: boolean = false;
  hasApp: boolean = false;
  isPortalChecked: boolean = false;
  isAppChecked: boolean = false;
  hasNoClientSign: boolean = false;
}

export class LetterShareStatus {
  hasSigned: boolean = false;
  hasSent: boolean = false;
  hasResent: boolean = false;
  sharedDate: string;
  statusTooltip: string;
  status: string;
  sendByUserName: string;
  resendByUserName: string;
  userInitials: string;
  isClientAccepted: boolean;
  clientApprovedAt: string;
}

export interface ClientSignReqModel {
  clientFirmId: number;
  signatureContent: string;
  isDrawSignature: boolean;
 engagementTemplateId: number;
}

export interface LetterPackageModel {
  engagementId: number;
  subModuleId: number;
  sourceFilePath: string;
  fileName: string;
  sectionName: string;
  clientFirmId: number;
  isCreatePackage: boolean;
  destinationFilePath: string;
}
